const Pending = (props) => {
    return <svg width="115" height="114" className={props.className} viewBox="0 0 115 114" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="5.5" y="5" width="104" height="104" rx="52" fill="#FEF0C7" />
        <rect x="5.5" y="5" width="104" height="104" rx="52" stroke="#FFFAEB" stroke-width="10" />
        <path d="M57.4993 43.0003V57.0003L66.8327 61.667M80.8327 57.0003C80.8327 69.887 70.386 80.3337 57.4993 80.3337C44.6127 80.3337 34.166 69.887 34.166 57.0003C34.166 44.1137 44.6127 33.667 57.4993 33.667C70.386 33.667 80.8327 44.1137 80.8327 57.0003Z" stroke="#DC6803" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
}

export default Pending;